export default "__VITE_ASSET__QklCThvq__"